export class Stack {
    size = 0; 
    sp = 0; 
    lista = null; 

    constructor(size, sp){
        this.size = size; 
        this.sp = sp; 
        this.lista = []; 
    }
    
}

